module.exports = __webpack_public_path__ + "media/images/emblems/Boenigen-coat_of_arms-1f5ea1255e2b2fb59ba3be50a03fd2d2.svg";